import React, { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import * as LazyComponent from "./LazyLoading";
import Loader from "../Components/Loader/Loader";
import ProtectedRoutes from "../Components/ProtectedRoutes/ProtectedRoutes";

const Routess = (
  <>
    <Suspense fallback={<Loader />}>
      <Routes>
        <Route
          path="/"
          element={
            <ProtectedRoutes
              path="/"
              component={LazyComponent.Home}
              permission={[
              ]}
            />
          }
        />
        <Route
          path="salaryGrade"
          element={
            <ProtectedRoutes
              path="salaryGrade"
              component={LazyComponent.AddNewSalaryGrade}
              permission={["Add_NEW_Salary_Grade"]}
            />
          }
        />
        <Route
          path="searchSalaryGrade"
          element={
            <ProtectedRoutes
              path="searchSalaryGrade"
              component={LazyComponent.SearchSalaryGrade}
              permission={["Search_Salary_Grade"]}
            />
          }
        />
        <Route
          path="allSalaryGrade"
          element={
            <ProtectedRoutes
              path="allSalaryGrade"
              component={LazyComponent.AllSalaryGrade}
              permission={["All_Salary_Grade"]}
            />
          }
        />
        <Route
          path="allTemplates"
          element={
            <ProtectedRoutes
              path="allTemplates"
              component={LazyComponent.AllTemplates}
              permission={["Add_Template"]}
            />
          }
        />
        <Route
          path="profile"
          element={
            <ProtectedRoutes
              path="profile"
              component={LazyComponent.Profile}
              permission={[]}
            />
          }
        />
        <Route
          path="jobdescriptions"
          element={
            <ProtectedRoutes
              path="jobdescriptions"
              component={LazyComponent.JobDescriptions}
              permission={["Add_Job_Description"]}
            />
          }
        />
        <Route
          path="jobDescriptionApproval"
          element={
            <ProtectedRoutes
              path="jobDescriptionApproval"
              component={LazyComponent.AllJobDescription}
              permission={["Approve_Job_Description"]}
            />
          }
        />{" "}
        <Route
          path="userJobDescription"
          element={
            <ProtectedRoutes
              path="userJobDescription"
              component={LazyComponent.UserJobDescription}
              permission={["Add_Job_Description"]}
            />
          }
        />
        <Route
          path="projects"
          element={
            <ProtectedRoutes
              path="projects"
              component={LazyComponent.Projects}
              permission={["View_Projects"]}
            />
          }
        />
        <Route
          path="projects/:projectId"
          element={
            <ProtectedRoutes
              path="projects/:projectId"
              component={LazyComponent.ProjectDetails}
              permission={["View_Projects"]}
            />
          }
        />{" "}
        <Route
          path="agentList"
          element={
            <ProtectedRoutes
              path="agentList"
              component={LazyComponent.AgentsList}
              permission={["Agents_List"]}
            />
          }
        />
        <Route
          path="addAgent"
          element={
            <ProtectedRoutes
              path="addAgent"
              component={LazyComponent.AddAgent}
              permission={["AddAgent"]}
            />
          }
        />
        <Route
          path="editAgent/:id"
          element={
            <ProtectedRoutes
              path="editAgent/:id"
              component={LazyComponent.AddAgent}
              permission={["AddAgent"]}
            />
          }
        />
        <Route
          path="addTemplate"
          element={
            <ProtectedRoutes
              path="addTemplate"
              component={LazyComponent.AddTemplate}
              permission={["Add_Template"]}
            />
          }
        />
        <Route
          path="editTemplate/:id"
          element={
            <ProtectedRoutes
              path="editTemplate/:id"
              component={LazyComponent.AddTemplate}
              permission={["Add_Template"]}
            />
          }
        />
        <Route
          path="roleList"
          element={
            <ProtectedRoutes
              path="roleList"
              component={LazyComponent.RoleList}
              permission={["AddAgent"]}
            />
          }
        />
        <Route
          path="addRole"
          element={
            <ProtectedRoutes
              path="addRole"
              component={LazyComponent.AddRole}
              permission={["AddAgent"]}
            />
          }
        />
        <Route
          path="addRole/:id"
          element={
            <ProtectedRoutes
              path="addRole/:id"
              component={LazyComponent.AddRole}
              permission={["AddAgent"]}
            />
          }
        />
        <Route
          path="proposal/:dealId"
          element={
            <ProtectedRoutes
              path="proposal/:dealId"
              component={LazyComponent.Proposal}
              permission={["Send_Client_Proposal_Request"]}
            />
          }
        />
        <Route
          path="loggedproposals"
          element={
            <ProtectedRoutes
              path="loggedproposals"
              component={LazyComponent.ProposalList}
              permission={["Send_Client_Proposal_Request"]}
            />
          }
        />
        <Route
          path="approvalproposals"
          element={
            <ProtectedRoutes
              path="approvalproposals"
              component={LazyComponent.ProposalList}
              permission={["Approve_Proposal_Request"]}
            />
          }
        />
        <Route
          path="assignedproposals"
          element={
            <ProtectedRoutes
              path="assignedproposals"
              component={LazyComponent.ProposalList}
              permission={[
                // "Send_Client_Proposal_Request",
                "Upload_Proposal_Request",
                // "Approve_Proposal_Request",r
              ]}
            />
          }
        />
        <Route
          path="deals"
          element={
            <ProtectedRoutes
              path="deals"
              component={LazyComponent.Deals}
              permission={["Deals"]}
            />
          }
        />
        <Route
          path="deals/:dealId"
          element={
            <ProtectedRoutes
              path="deals/:dealId"
              component={LazyComponent.SingleDeal}
              permission={["Deals"]}
            />
          }
        />
        <Route
          path="approvpeddings"
          element={
            <ProtectedRoutes
              path="approvpeddings"
              component={LazyComponent.BiddingList}
              permission={["Approve_Bidding_Request"]}
            />
          }
        />
        <Route
          path="biddinglist"
          element={
            <ProtectedRoutes
              path="biddinglist"
              component={LazyComponent.BiddingList}
              permission={["Send_Bidding_Request"]}
            />
          }
        />
        <Route
          path="addBidding"
          element={
            <ProtectedRoutes
              path="addBidding"
              component={LazyComponent.AddBidding}
              permission={["Send_Bidding_Request"]}
            />
          }
        />
        <Route
          path="editBidding/:id"
          element={
            <ProtectedRoutes
              path="editBidding/:id"
              component={LazyComponent.AddBidding}
              permission={["Send_Bidding_Request"]}
            />
          }
        />
        <Route
          path="businessAllocation"
          element={
            <ProtectedRoutes
              path="businessAllocation"
              component={LazyComponent.BusinessAllocation}
              permission={["Resource_Allocation"]}
            />
          }
        />
        <Route
          path="businessAllocation/:projectId"
          element={
            <ProtectedRoutes
              path="businessAllocation/:projectId"
              component={LazyComponent.AllocationResources}
              permission={["Resource_Allocation"]}
            />
          }
        />{" "}
        <Route
          path="resourceUtilization"
          element={
            <ProtectedRoutes
              path="resourceUtilization"
              component={LazyComponent.ResourceUtilization}
              permission={["Resource_Allocation"]}
            />
          }
        />{" "}

        <Route
          path="financial"
          element={
            <ProtectedRoutes
              path="financial"
              component={LazyComponent.Financial}
              permission={["NTP"]}
            />
          }
        />
        <Route
          path="myprojects"
          element={
            <ProtectedRoutes
              path="myprojects"
              component={LazyComponent.UserProjects}
              permission={[]}
            />
          }
        />
        <Route
          path="mytasks/:id"
          element={
            <ProtectedRoutes
              path="mytasks/:id"
              component={LazyComponent.UserTasks}
              permission={[]}
            />
          }
        />

        <Route
          path="noPermissions"
          element={
            <ProtectedRoutes
              path="noPermissions"
              component={LazyComponent.NoPermissions}
              permission={[]}
            />
          }
        />
        {/* <Route path="noPermissions" element={<LazyComponent.NoPermissions />} /> */}
        <Route path="login" element={<LazyComponent.Login />} />
        <Route path="otp" element={<LazyComponent.Otp />} />
        <Route
          path="forgetPassword"
          element={<LazyComponent.ForgetPassword />}
        />{" "}
        <Route path="resetpassword" element={<LazyComponent.ResetPassword />} />
      </Routes>
    </Suspense>
  </>
);

export default Routess;
